@import "./helpers/scss-helper";

:host {
  display: block;
  @include eon-typography();
  text-align: left;
  &:nth-child(odd) {
    opacity: 0.5;
  }
}

.#{$prefix}content-aggregator-item__list_expanded {
  text-decoration: none;
  outline-style: none;

  &--layout-align-left {
    flex-direction: row;

    @include for-size(phone) {
      flex-direction: column;
    }
  }

  &--layout-align-right {
    flex-direction: row-reverse;

    @include for-size(phone) {
      flex-direction: column;
    }

    .#{$prefix}content-aggregator-item__list_expanded--wrapper-section {
      .#{$prefix}content-aggregator-item__list_expanded--date {
        padding-left: 0;

        @include for-size(tablet) {
          justify-content: flex-start;
        }
      }
    }
  }

  &--wrapper {
    cursor: pointer;
    display: flex;
    font-family: $font-family-base;
    background-color: v(backgroundColor);

    &.#{$prefix}align-center {
      .#{$prefix}content-aggregator-item__list_expanded--tag-pill-group {
        align-self: center;
      }

      .#{$prefix}content-aggregator-item__list_expanded--date {
        align-self: center;
      }

      .#{$prefix}content-aggregator-item__list_expanded--content {
        align-items: center;
        text-align: center;
      }
    }

    &.#{$prefix}align-right {
      .#{$prefix}content-aggregator-item__list_expanded--tag-pill-group {
        align-self: flex-end;
      }

      .#{$prefix}content-aggregator-item__list_expanded--date {
        align-self: flex-end;
      }

      .#{$prefix}content-aggregator-item__list_expanded--content {
        align-items: flex-end;
        text-align: right;
      }
    }

    @include borderRadius("expanded_list_view", "content");
    @include boxShadow("expanded_list_view", "content");

    .#{$prefix}content-aggregator-item__list_expanded--zebra & {
      background-color: v(backgroundColor);
    }

    .#{$prefix}content-aggregator-item__list_expanded--shade & {
      background-color: v(backgroundColorShade);
    }

    @include for-size(phone) {
      flex-direction: column;
      padding: 0 0 32px;
    }

    @include for-size(tablet-or-larger) {
      padding: 32px 16px;
    }

    @include for-size(desktop-l-or-larger) {
      padding: 48px 24px;
    }

    &:hover {
      outline-style: none;
      @if variable-exists(content-aggregator-item-list-expanded-view-wrapper-hover-shadow) {
        .#{$prefix}content-aggregator-item__list_expanded--wrapper {
          &.#{$prefix}ultralightgrey {
            box-shadow: $content-aggregator-item-list-expanded-view-wrapper-hover-shadow;
          }
        }
      }
      @if (variable-exists(content-aggregator-item-list-expanded-view-hover-shadow-content)) {
        box-shadow: $content-aggregator-item-list-expanded-view-hover-shadow-content;
      }
      margin-bottom: -2px;
      border-bottom: 2px solid v(hoverColor);
    }
  }

  &--wrapper-section {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: flex-start;

    @include for-size(phone) {
      width: auto;
    }

    @include for-size(tablet-or-larger) {
      padding: 0 16px;
    }

    @include for-size(desktop-l-or-larger) {
      padding: 0 24px;
    }

    .#{$prefix}content-aggregator-item__list_expanded--date {
      order: -1; // Moves date to the top
      display: flex;
      eon-ui-date-event {
        --dateColor: var(--contentColor);
        --borderLeft: 1px solid var(--leftBorderColor);
      }

      .#{$prefix}content-aggregator-item__list_expanded--zebra & {
        eon-ui-date-event {
          --dateColor: var(--contentColor) !important;
        }
      }

      @include for-size(phone) {
        order: 2; // Moves date to the bottom
        padding: 0 16px 16px;

        .#{$prefix}content-aggregator-item__list_expanded--layout-align-right & {
          padding: 0 16px 16px;
        }
      }

      @include for-size(tablet-or-larger) {
        justify-content: flex-start;
        padding: 0 0 16px;

        .#{$prefix}content-aggregator-item__list_expanded--layout-align-left & {
          justify-content: flex-end;
        }
      }

      @include for-size(desktop-l-or-larger) {
        display: none;
      }
    }

    .#{$prefix}content-aggregator-item__list_expanded--no-image & {
      @include for-size(phone) {
        padding-top: 16px;
      }

      @include for-size(tablet-or-larger) {
        width: 33.33%;
      }
    }

    // This hides the date on left side when no text class is present
    // for desktop or larger view
    .#{$prefix}content-aggregator-item__list_expanded--no-abstract & {
      .#{$prefix}content-aggregator-item__list_expanded--date {
        display: none;
      }
    }
  }

  &--date-and-content-wrapper {
    display: flex;
    flex-direction: column;
  }

  &--image {
    margin-bottom: 16px;

    @include for-size(tablet-or-larger) {
      margin-bottom: 24px;
    }

    @include for-size(desktop-l-or-larger) {
      margin-bottom: 32px;
    }
    @include borderRadius("expanded_list_view", "image");
    @include boxShadow("expanded_list_view", "image");
  }

  &--tag-pill-group {
    @include for-size(phone) {
      display: flex;
      margin: 0 -2px;
      padding: 0 16px 24px 16px;
    }

    @include for-size(tablet-or-larger) {
      padding: 0;
    }

    margin: -8px;
  }

  &--image-and-tag-pill-group-wrapper {
    display: flex;
    flex-direction: column;

    @include for-size(tablet) {
      margin: 24px;
    }
  }

  &--content {
    font-family: $font-family-base;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    color: v(contentColor);
    padding: 0 16px;
    width: 50%;

    .#{$prefix}content-aggregator-item__list_expanded--date {
      display: none;
      eon-ui-date-event {
        --dateColor: var(--contentColor);
        --borderLeft: 1px solid var(--leftBorderColor);
      }
    }

    @include for-size(phone) {
      width: auto;
    }

    @include for-size(tablet-or-larger) {
      position: relative;
      bottom: 4px;
    }

    @include for-size(desktop-l-or-larger) {
      padding: 0 24px;

      .#{$prefix}content-aggregator-item__list_expanded--date {
        display: flex;
      }
    }

    .#{$prefix}content-aggregator-item__list_expanded--no-image & {
      @include for-size(tablet-or-larger) {
        width: 66.66%;
      }
    }

    // This shows the date on right side when no text class is present
    // for desktop or larger view
    .#{$prefix}content-aggregator-item__list_expanded--no-abstract & {
      .#{$prefix}content-aggregator-item__list_expanded--date {
        display: flex;
      }
    }
  }

  &--headline {
    text-align: left;
    padding-bottom: 16px;

    .#{$prefix}content-aggregator-item__list_expanded--zebra & {
      eon-ui-headline {
        color: v(contentColor);
      }
    }

    & + .#{$prefix}content-aggregator-item__list-expanded--links {
      // targets the links
      padding-top: 8px;

      @include for-size(tablet-or-larger) {
        padding-top: 16px;
      }
    }
  }

  &--category {
    color: v(contentColor);
    overflow-wrap: break-word;
    word-break: break-word;

    .#{$prefix}content-aggregator-item__list_expanded--zebra & {
      color: v(contentColor);
    }
  }

  &--body {
    .#{$prefix}content-aggregator-item__list_expanded--zebra & {
      eon-ui-text {
        color: v(contentColor);
      }
    }

    & + .#{$prefix}content-aggregator-item__list-expanded--links {
      // targets the links
      padding-top: 24px;

      @include for-size(tablet-or-larger) {
        padding-top: 32px;
      }
    }
  }

  &--date {
    font-family: $font-family-base;

    @include for-size(phone) {
      padding-bottom: 16px;
    }

    @include for-size(tablet-or-larger) {
      padding-bottom: 24px;
    }
    @include for-size(desktop-l-or-larger) {
      padding-bottom: 32px;
    }

    &.#{$prefix}list-category {
      @include for-size(tablet-or-larger) {
        min-width: 88px;
      }

      @include for-size(desktop-l-or-larger) {
        min-width: 90px;
      }
    }

    &.#{$prefix}hour-format {
      @include for-size(tablet-or-larger) {
        min-width: 130px;
      }
    }
  }
}

.#{$prefix}content-aggregator-item__list_expanded--zebra {
  ::slotted(eon-ui-link) {
    --contentColor: var(--linkColor) !important;
    --contentHoverColor: var(--linkHoverColor) !important;
  }
}
